module.exports = {
  title: 'Blockquote',
  context: {
    citeUrl: 'https://www.madebyraygun.com',
    cite: 'Quote Website',
    attribution: 'Quote Author',
    text: '&ldquo;Belonging is what happens when our approach to care meets the real needs of the people we serve.&rdquo;'
  }
}
